import type { SVGProps } from 'react'
const SvgShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="#0F141E"
      strokeWidth={1.5}
      d="M4.269 18.987c-.484.27-.896.54-1.244.8.232-1.136.657-2.59 1.43-4.044 1.616-3.047 4.778-6.157 11.129-6.295l.733-.016V4.82q-.001-.01.01-.026a.1.1 0 0 1 .046-.035.15.15 0 0 1 .082-.008q.043.01.063.03l.001.002 8.664 8.07q.035.034.051.071a.18.18 0 0 1 0 .146.2.2 0 0 1-.051.071l-8.661 8.075h-.001a.13.13 0 0 1-.064.03.15.15 0 0 1-.082-.008.1.1 0 0 1-.048-.035.05.05 0 0 1-.01-.027v-4.603l-.758.008c-5.632.058-9.152 1.213-11.29 2.405Z"
    />
  </svg>
)
export default SvgShare
